import { useState, useEffect } from 'react'; 
import ListCard from '../../components/ListCard';
import { MISC } from '../../data/Misc';

function MiscellaneousContainer(){
    const [misc, setMisc] = useState([]);
    useEffect(() => {
        setMisc(MISC);
    }, [])
    return <main className="home-container">
        <ListCard title="Varios" items={misc} path="varios"/>
    </main>    
}

export default MiscellaneousContainer;